import { useFormik } from 'formik';
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';

import { AddRotationPlan, GetRotationPlan } from '../../../store/HR/Raqeeb/raqeebSlice.js';
import { formRaqeebSchema } from '../../ValidationForm/validationSchema';

// import { usePermissions } from '../../../Helper/Permisstions/usePermissions';

const CreateRotationPlan = () => {
  // const { HasPermission } = usePermissions();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name: '',
      name2: '',
      startDate: '',
      endDate: '',
      description: '',
      // allowIn: '',
      // allowOut: '',
      // count_Fingerprint: '',
    },
    validationSchema: formRaqeebSchema(t),
    onSubmit: (values) => {
      dispatch(
        AddRotationPlan({
          name: values.name,
          name2: values.name2,
          startDate: values.startDate,
          endDate: values.endDate,
          description: values.description,
          // allowIn: values.allowIn,
          // allowOut: values.allowOut,
          // count_Fingerprint: values.count_Fingerprint,
          // businessGroupId: "b1a1ffb9-2205-4db6-bb5f-8a8c8e9bda87",
          // // businessGroupId: '00000000-1111-2222-3333-AAAAAAAAAA00',
        })
      )
        .unwrap()
        .then(() => {
          formik.resetForm();
          CustomAlert({ action: 'Add' });
          dispatch(GetRotationPlan());
        })
        .catch((error) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    },
  });
  return (
    <div>
      <Form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-xl-6">
            <div className="form-group mb-3">
              <label className="form-label">{t('LocalName')}</label>
              <Form.Control
                className="form-control"
                type="text"
                autoComplete="off"
                name="name2"
                onChange={formik.handleChange}
                value={formik.values.name2}
                isInvalid={!!formik.errors.name2}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.name2}</Form.Control.Feedback>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="form-group mb-3">
              <label className="form-label">{t('GlobalName')}</label>
              <Form.Control
                className="form-control"
                type="text"
                autoComplete="off"
                name="name"
                onChange={formik.handleChange}
                value={formik.values.name}
                isInvalid={!!formik.errors.name}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
            </div>
          </div>


          {/* <div className="col-xl-4">
            <div className="form-group mb-3">
              <label className="form-label">{t('NumberOfFingerprints')}</label>

              <Form.Select
                className="form-select"
                name="count_Fingerprint"
                onChange={formik.handleChange}
                value={formik.values.count_Fingerprint}
                isInvalid={formik.touched.count_Fingerprint && formik.errors.count_Fingerprint}>
                <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                <option value="1">بصمة واحدة</option>

                <option value="2">بصمتــــان</option>

                <option value="4">4 بصمــات</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {formik.errors.count_Fingerprint}
              </Form.Control.Feedback>
            </div>
          </div> */}

        </div>

        <div className="row">
          {/* <div className="col-xl-3">
            <div className="form-group mb-3">
              <label className="form-label">{t('AllowIn')}</label>
              <Form.Control
                type="time"
                className="form-c ontrol"
                name="allowIn"
                onChange={formik.handleChange}
                value={formik.values.allowIn}
                isInvalid={formik.touched.allowIn && formik.errors.allowIn}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.allowIn}</Form.Control.Feedback>
            </div>
          </div> */}

          {/* <div className="col-xl-3">
            <div className="form-group mb-3">
              <label className="form-label">{t('AllowOut')}</label>
              <Form.Control
                type="time"
                className="form-c ontrol"
                name="allowOut"
                onChange={formik.handleChange}
                value={formik.values.allowOut}
                isInvalid={formik.touched.allowOut && formik.errors.allowOut}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.allowOut}</Form.Control.Feedback>
            </div>
          </div> */}

          <div className="col-xl-6">
            <div className="form-group mb-3">
              <label className="form-label">{t('Start Date')}</label>
              <Form.Control
                type="date"
                className="form-c ontrol"
                name="startDate"
                onChange={formik.handleChange}
                value={formik.values.startDate}
                isInvalid={formik.touched.startDate && formik.errors.startDate}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.startDate}
              </Form.Control.Feedback>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="form-group mb-3">
              <label className="form-label">{t('Date_TO')}</label>
              <Form.Control
                type="date"
                className="form-c ontrol"
                name="endDate"
                onChange={formik.handleChange}
                value={formik.values.endDate}
                isInvalid={formik.touched.endDate && formik.errors.endDate}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.endDate}</Form.Control.Feedback>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="form-group mb-3">
              <label className="form-label">{t('Note')}</label>
              <Form.Control
                className="form-control"
                as="textarea"
                rows={3}
                name="description"
                onChange={formik.handleChange}
                value={formik.values.description}
                isInvalid={formik.touched.description && formik.errors.description}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.description}
              </Form.Control.Feedback>
              <div></div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="d-flex justify-content-between gap-2">
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-lg btn-theme mb-1 w-100">
              {formik.isSubmitting ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                <i className="fas fa-save fa-lg fa-fw me-2"></i>
              )}
              {t('Add')}
            </button>
            <button
              type="button"
              className="btn btn-lg  btn-default mb-1 w-100"
              data-bs-dismiss="modal"
              id="closeModalJob">
              <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CreateRotationPlan;
